// Final Product Card Image Slider - Clean version
(function() {
  'use strict';

  function createImageSlider() {
    const productCards = document.querySelectorAll('.card-wrapper.product-card-wrapper');

    productCards.forEach(function(cardWrapper, cardIndex) {
      const mediaContainer = cardWrapper.querySelector('.media.media--hover-effect');
      if (!mediaContainer) return;

      const images = Array.from(mediaContainer.querySelectorAll('img'));
      if (images.length <= 1) return;

      let currentIndex = 0;

      // Setup images - keep first visible, hide others
      images.forEach(function(img, index) {
        if (index === 0) {
          img.style.opacity = '1';
          img.style.display = 'block';
        } else {
          img.style.opacity = '0';
        }
      });

      // Check if mobile
      const isMobile = window.innerWidth <= 749;

      // Create navigation arrows
      const prevBtn = document.createElement('button');
      prevBtn.innerHTML = '‹';
      prevBtn.type = 'button';
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.style.cssText = `
        position: absolute;
        top: ${isMobile ? '30%' : '40%'};
        left: 1px;
        transform: translateY(-50%);
        z-index: 999;
        background: rgba(255, 255, 255, 0.9);
        color: #333;
        border: none;
        width: ${isMobile ? '24px' : '32px'};
height: ${isMobile ? '40px' : '60px'};
        cursor: pointer;
        font-size: ${isMobile ? '14px' : '18px'};
        font-weight: bold;
        transition: all 0.2s ease;
        box-shadow:none;
        opacity: ${isMobile ? '1' : '0'};
        pointer-events: ${isMobile ? 'auto' : 'none'};
      `;

      const nextBtn = document.createElement('button');
      nextBtn.innerHTML = '›';
      nextBtn.type = 'button';
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.style.cssText = `
        position: absolute;
        top: ${isMobile ? '30%' : '40%'};
        right: 1px;
        transform: translateY(-50%);
        z-index: 999;
        background: rgba(255, 255, 255, 0.9);
        color: #333;
        border: none;
        width: ${isMobile ? '24px' : '32px'};
height: ${isMobile ? '40px' : '60px'};
        cursor: pointer;
        font-size: ${isMobile ? '14px' : '18px'};
        font-weight: bold;
        transition: all 0.2s ease;
        box-shadow:none;
        opacity: ${isMobile ? '1' : '0'};
        pointer-events: ${isMobile ? 'auto' : 'none'};
      `;

      // Add hover effects
      // [prevBtn, nextBtn].forEach(function(btn) {
      //   btn.addEventListener('mouseenter', function() {
      //     this.style.background = 'rgba(255, 255, 255, 1)';
      //     this.style.transform = 'translateY(-50%) scale(1.1)';
      //   });
      //   btn.addEventListener('mouseleave', function() {
      //     this.style.background = 'rgba(255, 255, 255, 0.9)';
      //     this.style.transform = 'translateY(-50%) scale(1)';
      //   });
      // });
// Add subtle hover transparency
[prevBtn, nextBtn].forEach(function(btn) {
  btn.addEventListener('mouseenter', function() {
    this.style.background = 'rgba(255, 255, 255, 0.8)'; // slightly transparent
  });
  btn.addEventListener('mouseleave', function() {
    this.style.background = 'rgba(255, 255, 255, 1)'; // back to solid
  });
});

      // Position card wrapper as relative
      cardWrapper.style.position = 'relative';

      // Add buttons to card wrapper
      cardWrapper.appendChild(prevBtn);
      cardWrapper.appendChild(nextBtn);

      // Show arrows on card hover (desktop only)
      if (!isMobile) {
        cardWrapper.addEventListener('mouseenter', function() {
          prevBtn.style.opacity = '1';
          nextBtn.style.opacity = '1';
          prevBtn.style.pointerEvents = 'auto';
          nextBtn.style.pointerEvents = 'auto';
        });

        cardWrapper.addEventListener('mouseleave', function() {
          prevBtn.style.opacity = '0';
          nextBtn.style.opacity = '0';
          prevBtn.style.pointerEvents = 'none';
          nextBtn.style.pointerEvents = 'none';
        });
      }

      // Navigation functions
      function showImage(index) {
        images.forEach(function(img, i) {
          img.style.opacity = i === index ? '1' : '0';
        });
        currentIndex = index;
      }

      function nextImage() {
        const newIndex = (currentIndex + 1) % images.length;
        showImage(newIndex);
      }

      function prevImage() {
        const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
        showImage(newIndex);
      }

      // Button click handlers
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        prevImage();
        return false;
      });

      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        nextImage();
        return false;
      });
    });
  }

  // Initialize sliders
  function init() {
    // Remove any existing sliders first
    document.querySelectorAll('[aria-label="Previous image"], [aria-label="Next image"]').forEach(btn => btn.remove());

    createImageSlider();
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }

  // Re-initialize when sections load (for Shopify theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });

})();